class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.disclosure__button');
    this.list = this.querySelector('.disclosure__list');
    this.form = this.querySelector('form');
    
    if (this.button && this.list) {
      this.button.addEventListener('click', this.toggleList.bind(this));
      document.addEventListener('click', this.closeList.bind(this));
    }
  }

  toggleList() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true' ? false : true;
    this.button.setAttribute('aria-expanded', expanded);
    this.list.hidden = !expanded;
  }

  closeList(event) {
    if (!this.contains(event.target)) {
      this.button.setAttribute('aria-expanded', 'false');
      this.list.hidden = true;
    }
  }
}

customElements.define('localization-form', LocalizationForm);